import type React from "react";

import {faPencilAlt} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import CustomButton from "~/component/common/CustomButton";

import useModal from "../../../../hooks/useModal";
import RenamePlaylistContent from "./RenamePlaylistContent";

const RenamePlaylistModalButton: React.FC = () => {
  const {openModal, closeModal, Modal} = useModal();

  return (
    <>
      <CustomButton
        onClick={openModal}
        className="p-2 rounded-full hover:bg-black hover:bg-opacity-70 transition-colors"
        title="Rename Playlist"
      >
        <FontAwesomeIcon
          icon={faPencilAlt}
          size="xl"
          className="text-white p-2 -m-2 rounded-full bg-gradient-to-br from-blue-600 via-blue-500 to-blue-700"
        />
      </CustomButton>
      <Modal>
        <RenamePlaylistContent closeModal={closeModal} />
      </Modal>
    </>
  );
};

export default RenamePlaylistModalButton;
